import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './TermsOfServcie.css';

const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className='terms-of-service-container'>
      <div className="terms-of-service-title">Terms of Service</div>
      
      {/* COMING SOON NOTICE - Remove this section once business is live and location is finalized */}
      <div className="terms-of-service-notice">
        <strong>Important Notice:</strong> DJ's Dog Bar is currently in a "coming soon" phase. 
        We are not yet open for business and do not have a finalized location. These terms are 
        subject to change prior to our official opening. By using our website and services, you 
        acknowledge that you have read, understood, and agree to be bound by these terms.
      </div>

      <div className="terms-section">
        <h2 className="terms-section-title">1. Overview</h2>
        <p className="terms-content">
          These Terms of Service ("Terms") govern your access to and use of DJ's Dog Bar's 
          website, services, and facilities. By creating an account, accessing our website, or 
          visiting our premises (once open), you agree to comply with and be bound by these Terms. 
          If you do not agree to these Terms, you must not use our services.
        </p>
      </div>

      <div className="terms-section">
        <h2 className="terms-section-title">2. Changes to Terms</h2>
        <p className="terms-content">
          We reserve the right to modify these Terms at any time. Since we are in a pre-opening 
          phase, these Terms may change significantly before we officially open. We will notify 
          users of material changes via email or through our website. Your continued use of our 
          services after such changes constitutes your acceptance of the new Terms. It is your 
          responsibility to review these Terms periodically.
        </p>
      </div>

      <div className="terms-section">
        <h2 className="terms-section-title">3. Account Registration</h2>
        <p className="terms-content">
          To use certain features of our services, you must create an account. You agree to:
        </p>
        <ul className="terms-list">
          <li>Provide accurate, current, and complete information during registration</li>
          <li>Maintain and promptly update your account information</li>
          <li>Maintain the security of your password and account</li>
          <li>Accept responsibility for all activities that occur under your account</li>
          <li>Notify us immediately of any unauthorized use of your account</li>
        </ul>
        <p className="terms-content">
          We reserve the right to suspend or terminate accounts that violate these Terms or engage 
          in fraudulent, illegal, or harmful activities.
        </p>
      </div>

      <div className="terms-section">
        <h2 className="terms-section-title">4. Park Rules and Family Guidelines</h2>
        <p className="terms-content">
          All visitors to DJ's Dog Bar must comply with our Park Rules and, if applicable, our 
          Family Guidelines. These rules are designed to ensure the safety and enjoyment of all 
          guests and their dogs. You can view our complete Park Rules <Link to="/Rules" className="terms-link">here</Link> 
          {' '}and our Family Guidelines <Link to="/Dog-House-Rules" className="terms-link">here</Link>.
        </p>
        <p className="terms-content">
          Key requirements include:
        </p>
        <ul className="terms-list">
          <li>All dogs must be registered and have current vaccinations (Rabies and DAP/DHPP/DHLPP/Da2PP)</li>
          <li>All dogs must be neutered or spayed</li>
          <li>Maximum of three dogs per person</li>
          <li>No individuals under 21 years of age (except as outlined in Family Guidelines)</li>
          <li>Dogs must be in good health and exhibit friendly behavior</li>
          <li>Owners are responsible for their dogs' behavior at all times</li>
        </ul>
        <p className="terms-content">
          <em>Note: While our system tracks vaccination records and expiration dates, final 
          verification of all requirements (including vaccination status, spay/neuter status, 
          age requirements, and maximum dogs per person) occurs at check-in by our staff. Our 
          system will alert you if vaccinations are expired, but entry decisions are made by our 
          staff at the time of your visit.</em>
        </p>
        <p className="terms-content">
          We reserve the right to refuse entry or remove any person or dog that violates these rules 
          or poses a risk to others.
        </p>
      </div>

      <div className="terms-section">
        <h2 className="terms-section-title">5. Waiver and Release of Liability</h2>
        <p className="terms-content">
          Before visiting DJ's Dog Bar, all visitors must sign a waiver agreeing to our Park Rules. 
          If you have children under 21, you must also sign our Family Guidelines waiver. By signing 
          these waivers, you acknowledge that:
        </p>
        <ul className="terms-list">
          <li>You have read and understand all Park Rules and Family Guidelines (if applicable)</li>
          <li>You are responsible for your own safety and the safety of your dog(s)</li>
          <li>You knowingly and voluntarily assume all risks associated with visiting DJ's Dog Bar</li>
          <li>You release DJ's Dog Bar, its owners, employees, and agents from any liability for 
              injuries, damages, or losses that may occur on the premises</li>
        </ul>
        <p className="terms-content">
          Waivers must be signed before your first visit and can be completed online through your 
          account profile or in person at our facility. You may be asked to re-sign waivers if 
          rules are updated.
        </p>
      </div>

      <div className="terms-section">
        <h2 className="terms-section-title">6. Dog Registration and Vaccination Requirements</h2>
        <p className="terms-content">
          All dogs must be registered with DJ's Dog Bar either online or at our check-in desk. 
          You must provide accurate information about your dog, including:
        </p>
        <ul className="terms-list">
          <li>Dog's name, breed, and date of birth</li>
          <li>Current vaccination records (Rabies and DAP/DHPP/DHLPP/Da2PP)</li>
          <li>Any relevant health or behavioral information</li>
        </ul>
        <p className="terms-content">
          You are responsible for keeping your dog's vaccination records current and up to date in 
          our system. While our system tracks vaccination records and will alert you to expired 
          vaccinations, final verification of vaccination status and all other requirements occurs 
          at check-in by our staff. Dogs with expired vaccinations will not be permitted entry until 
          vaccinations are renewed and verified.
        </p>
      </div>

      <div className="terms-section">
        <h2 className="terms-section-title">7. Membership and Payment Terms</h2>
        <p className="terms-content">
          DJ's Dog Bar may offer various membership options and payment plans. By purchasing a 
          membership or making a payment, you agree to:
        </p>
        <ul className="terms-list">
          <li>Pay all fees associated with your membership or visit</li>
          <li>Provide accurate payment information</li>
          <li>Authorize us to charge your payment method for recurring memberships</li>
          <li>Comply with any cancellation policies that apply to your membership</li>
        </ul>
        <p className="terms-content">
          Membership terms, pricing, and policies are subject to change. We will provide notice of 
          material changes to existing members. Refund policies will be communicated at the time 
          of purchase.
        </p>
      </div>

      <div className="terms-section">
        <h2 className="terms-section-title">8. User Conduct</h2>
        <p className="terms-content">
          You agree not to:
        </p>
        <ul className="terms-list">
          <li>Use our services for any illegal purpose or in violation of any laws</li>
          <li>Interfere with or disrupt our services or servers</li>
          <li>Attempt to gain unauthorized access to any part of our services</li>
          <li>Harass, threaten, or harm other users, staff, or animals</li>
          <li>Post false, misleading, or defamatory content</li>
          <li>Violate any of our Park Rules or Family Guidelines</li>
        </ul>
      </div>

      <div className="terms-section">
        <h2 className="terms-section-title">9. Intellectual Property</h2>
        <p className="terms-content">
          All content on our website, including text, graphics, logos, images, and software, is the 
          property of DJ's Dog Bar or its licensors and is protected by copyright and other 
          intellectual property laws. You may not reproduce, distribute, or create derivative works 
          from our content without our express written permission.
        </p>
      </div>

      <div className="terms-section">
        <h2 className="terms-section-title">10. Limitation of Liability</h2>
        <p className="terms-content">
          TO THE MAXIMUM EXTENT PERMITTED BY LAW, DJ'S DOG BAR SHALL NOT BE LIABLE FOR ANY INDIRECT, 
          INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, 
          WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER 
          INTANGIBLE LOSSES RESULTING FROM YOUR USE OF OUR SERVICES.
        </p>
        <p className="terms-content">
          By visiting DJ's Dog Bar, you acknowledge that interactions with dogs and other animals 
          involve inherent risks. You assume full responsibility for your safety and the safety of 
          your dog(s).
        </p>
      </div>

      <div className="terms-section">
        <h2 className="terms-section-title">11. Indemnification</h2>
        <p className="terms-content">
          You agree to indemnify, defend, and hold harmless DJ's Dog Bar, its owners, employees, 
          agents, and affiliates from any claims, damages, losses, liabilities, and expenses 
          (including legal fees) arising from your use of our services, violation of these Terms, 
          or your dog's behavior while on our premises.
        </p>
      </div>

      <div className="terms-section">
        <h2 className="terms-section-title">12. Termination</h2>
        <p className="terms-content">
          We reserve the right to suspend or terminate your account and access to our services at 
          any time, with or without cause or notice, for any reason including, but not limited to, 
          violation of these Terms, violation of our Park Rules, or behavior that we determine to 
          be harmful to other guests or our business.
        </p>
      </div>

      <div className="terms-section">
        <h2 className="terms-section-title">13. Governing Law</h2>
        <p className="terms-content">
          These Terms shall be governed by and construed in accordance with the laws of the 
          jurisdiction in which DJ's Dog Bar operates, without regard to its conflict of law 
          provisions. Any disputes arising from these Terms or your use of our services shall be 
          resolved in the appropriate courts of that jurisdiction.
        </p>
      </div>

      <div className="terms-section">
        <h2 className="terms-section-title">14. Contact Information</h2>
        <p className="terms-content">
          If you have any questions about these Terms of Service, please contact us through our 
          website or at the contact information provided on our website.
        </p>
      </div>

      <div className="terms-section">
        <h2 className="terms-section-title">15. Severability</h2>
        <p className="terms-content">
          If any provision of these Terms is found to be unenforceable or invalid, that provision 
          shall be limited or eliminated to the minimum extent necessary, and the remaining 
          provisions shall remain in full force and effect.
        </p>
      </div>

      <div className="terms-last-updated">
        <p><em>Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</em></p>
        <p><em>Note: These terms are subject to change as we prepare for our official opening.</em></p>
      </div>
    </div>
  );
};

export default TermsOfService;
